export default "__VITE_ASSET__yzATyQD___"